export default __webpack_public_path__ + "static/iconText-68eda63e4433782b44ae93e99cf6b692.png";